import * as tslib_1 from "tslib";
import { Location } from '@angular/common';
import * as _ from 'lodash';
import * as momentImported from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs/Subject';
import { TranslateService } from '@ngx-translate/core';
import { clearAllUtil, clearByTypeUtil, clearSelectedFiltersByTypeUtil } from '../utils/clear-filters.utils';
import { EventService } from '../../services/event-service/event.service';
import FILTERS_UTILS from '../utils/filters.utils';
import { filterMappers } from '../mappers/mappers';
import { getSpecialtyName } from '../mappers/more-filters.mapper';
import { LocalStorageService } from '../../services/local-storage-service/local-storage.service';
import { QUICK_QUOTE_CONSTANTS } from '../quick-quote.constants';
import { ReservationIdService } from '../../services/reservation-id/reservation-id.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { TravelPartyService } from '../../travel-party/services/travel-party.service';
import { WindowRef } from '../../window-ref/window-ref.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service/cookie-service/cookie.service";
import * as i2 from "../../services/event-service/event.service";
import * as i3 from "../../services/local-storage-service/local-storage.service";
import * as i4 from "@angular/common";
import * as i5 from "../../services/reservation-id/reservation-id.service";
import * as i6 from "../../services/session-storage/session-storage.service";
import * as i7 from "@ngx-translate/core";
import * as i8 from "../../travel-party/services/travel-party.service";
import * as i9 from "../../window-ref/window-ref.service";
var QuickQuoteService = /** @class */ (function () {
    function QuickQuoteService(cookieService, eventService, localStorageService, location, reservationIdService, sessionStorageService, translate, travelPartyService, windowRef) {
        this.cookieService = cookieService;
        this.eventService = eventService;
        this.localStorageService = localStorageService;
        this.location = location;
        this.reservationIdService = reservationIdService;
        this.sessionStorageService = sessionStorageService;
        this.translate = translate;
        this.travelPartyService = travelPartyService;
        this.windowRef = windowRef;
        this.clearAllFiltersUtil = clearAllUtil;
        this.constants = QUICK_QUOTE_CONSTANTS;
        this.filtersUtils = FILTERS_UTILS;
        this.focusBar = new Subject();
        this.modelChanged$ = new Subject();
        this.onApplyFilters = new Subject();
        this.removeFiltersByType = clearByTypeUtil;
        this.removeSelectedFiltersByType = clearSelectedFiltersByTypeUtil;
        this.selectedFiltersList = [];
        this.tpFilterKeys = this.constants.travelPartyFilterKeys;
        this.urlDelimiters = this.constants.urlDelimiters;
        this.urlFilters = new Subject();
        this.dclClRefactorPhase2Toogle = false;
        this.dclAdvancedBooking = false;
        this.disableFilterDictionary = {};
    }
    /**
     * Create an subject from analytics data model
     * @param analyticsData analytics model
     */
    QuickQuoteService.prototype.trackAnalyticsEvent = function (analyticsData) {
        this.eventService.sendNextItem({
            name: this.constants.analytics.analyticsSubjectEvent,
            value: analyticsData
        });
    };
    /**
     * Returns the filter model
     */
    QuickQuoteService.prototype.getModel = function () {
        return this.model;
    };
    /**
     * Sets the model parsing the data provided by the data param
     * @param data Raw filters data
     * @return The filter data with the model format
     */
    QuickQuoteService.prototype.setModel = function (data) {
        this.model = this.parseData(data);
        this.filtersData = data;
        this.selectedFilters = this.initSelectedFilters(this.selectedFilters);
        this.selectedDoneFilters = this.initSelectedFilters(this.selectedDoneFilters);
        this.tempSelectedFilters = this.initSelectedFilters(this.tempSelectedFilters);
        return this.model;
    };
    /**
     * Returns the filters raw data
     */
    QuickQuoteService.prototype.getFiltersData = function () {
        return this.filtersData;
    };
    /**
     * Returns the filter selected
     */
    QuickQuoteService.prototype.getFiltersSelected = function () {
        return this.selectedFilters;
    };
    /**
     * Returns the temp selected filters
     */
    QuickQuoteService.prototype.getTempFiltersSelected = function () {
        return this.tempSelectedFilters;
    };
    /**
     * returns the contextPath saved
     */
    QuickQuoteService.prototype.getContextPath = function () {
        return this.contextPath;
    };
    /**
     * Returns the special filter
     * @returns special filter
     */
    QuickQuoteService.prototype.getSpecialFilter = function () {
        return this.specialFilter;
    };
    /**
     * sets the context got from the SPA
     *
     * @param contextPath
     */
    QuickQuoteService.prototype.setContextPath = function (contextPath) {
        this.contextPath = contextPath;
    };
    /**
     * Verify if the screen width is mobile or desktop depending on given breakpoint
     * @returns true if is mobile or false otherwise
     */
    QuickQuoteService.prototype.verifyIsMobile = function () {
        return this.windowRef.nativeWindow.innerWidth <= this.constants.viewBreakpoints.mobile;
    };
    /**
     * Parse the data to the model format
     * This function iterates on the data object to convert the object to a filters array.
     * First, it asks if a filter item was already created with the type of the item,
     * if the filter item was not created, creates a new filter item, and calls the mapper associate with this type,
     * finally adds the new filter item to the final array result.
     * If the filter item was already created by a previous item, the data of the item is just add to the data property
     * of the filter item after map its value.
     *
     * Note that to add filter items to the final array we use a renderOrder property of each filter,
     * it is because to render the filters in the proper way, we need that filters ordered in a specific way
     * @param data Raw filters data
     */
    QuickQuoteService.prototype.parseData = function (data) {
        var _this = this;
        var filtersResult = [];
        _.forIn(data, function (filterData) {
            // Save special filter coming from special offer or port of call
            if (_this.constants.specialFilters.includes(filterData.type)) {
                _this.specialFilter = filterData;
                return;
            }
            // Avoid unnecessary processing for hidden filters
            if (filterData.hiddenFilter) {
                return;
            }
            var filterType = _this.constants.filters[filterData.type]
                ? filterData.type
                : _this.constants.filters['more-filters'].id;
            var filterParsed = filtersResult.find(function (filter) { return filter && filter.type === filterType; });
            // Define isDisabled flag value with dictionary
            if (_this.disableFilterDictionary[filterType]) {
                filterParsed['isDisabled'] = _this.disableFilterDictionary[filterType];
            }
            if (filterParsed) {
                _this.addItemToFilter(filterType, filterData, filterParsed);
            }
            else {
                var translationkeys = _this.getTranslationKeys(filterType);
                var newfilterParsed = {
                    type: filterType,
                    headingKey: translationkeys.heading,
                    nameKey: translationkeys.name,
                    value: translationkeys.defaultValue,
                    modalValue: translationkeys.defaultValue,
                    isSubgroup: _this.constants.filters[filterType].isSubgroup,
                    data: []
                };
                _this.addItemToFilter(filterType, filterData, newfilterParsed);
                filtersResult[_this.constants.filters[filterType].renderOrder] = newfilterParsed;
            }
        });
        filtersResult[this.constants.filters['travel-party'].renderOrder] = tslib_1.__assign({}, this.getTravelPartyFilter(), { isDisabled: this.disableFilterDictionary['travel-party'] });
        return filtersResult;
    };
    /**
     * Calls the mapper associate with the filterType param and applies it to the filterData param,
     * finally adds it into the data property of the filterObject param
     * @param filterType Filter type
     * @param filterData Raw filter data
     * @param filterObject Filter item
     */
    QuickQuoteService.prototype.addItemToFilter = function (filterType, filterData, filterObject) {
        var mapper = filterMappers[filterType];
        if (mapper) {
            if (filterData.isEarlyBooking && !filterObject.isEarlyBooking) {
                filterObject.isEarlyBooking = true;
            }
            if (filterType === this.constants.filters['more-filters'].id) {
                filterData.name = this.translate.instant(getSpecialtyName(filterData));
            }
            mapper(filterData, filterObject.data);
        }
        else {
            filterObject.data.push(filterData);
        }
    };
    /**
     * Returns the filter item for the Travel Party filter
     */
    QuickQuoteService.prototype.getTravelPartyFilter = function () {
        // The value for the Travel Party should be calculated, so this method should be updated after
        // Travel Party component be created
        var guestCount = this.travelPartyService.getTravelPartyCount();
        return {
            type: this.constants.filters['travel-party'].id,
            headingKey: this.constants.filters['travel-party'].headingKey,
            nameKey: this.constants.filters['travel-party'].nameKey,
            value: this.getTranslatedTravelPartySubHeading(guestCount),
            modalValue: this.getTranslatedTravelPartySubHeading(guestCount),
            data: []
        };
    };
    /**
     * Get the corresponding translation for travel party depending on the travel party count
     * @param travelPartyCount
     * @returns the corresponding translation
     */
    QuickQuoteService.prototype.getTranslatedTravelPartySubHeading = function (travelPartyCount) {
        var travelPartyCountLabel;
        var defaultValue = this.tpFilterKeys.defaultValuePlural;
        if (travelPartyCount === 1) {
            defaultValue = this.tpFilterKeys.defaultValueSingular;
        }
        travelPartyCountLabel = this.translate.instant(this.constants.filters['travel-party'][defaultValue], { count: travelPartyCount });
        return travelPartyCountLabel;
    };
    /**
     * Returns the translations keys associate with the filterType param
     * @param filterType Filter type
     */
    QuickQuoteService.prototype.getTranslationKeys = function (filterType) {
        var filterKeysData = this.constants.filters[filterType];
        return {
            heading: filterKeysData.headingKey,
            name: filterKeysData.nameKey,
            defaultValue: filterKeysData.defaultValue
        };
    };
    /**
     * Validates that the filter selected has errors by calling its corresponding service
     * @param index Filter index
     */
    QuickQuoteService.prototype.filterHasErrors = function (index) {
        var hasErrors = false;
        if (index) {
            var filterType = this.model[index].type;
            switch (filterType) {
                case 'travel-party':
                    hasErrors = this.travelPartyService.getStateroomsWithErrors().length > 0;
            }
        }
        return hasErrors;
    };
    /**
     * Initialize the selected filters object to save the ids that are been selected in the same order
     * that the model has the filters type.
     * For 'more filters' type, wil generate an array for each group type (theme, ship, night)
     * @param filterArray
     *
     * @returns An array that reflects the model structure
     */
    QuickQuoteService.prototype.initSelectedFilters = function (filterArray) {
        var _this = this;
        filterArray = [];
        this.model.forEach(function (model, filterIndex) {
            filterArray.push([]);
            if (model.type === _this.constants.filters['more-filters'].id) {
                model.data.forEach(function () {
                    filterArray[filterIndex].push([]);
                });
            }
        });
        // privateIsland can be disabled from Service side
        // @TODO remove once privateIsland and Phase2 are enabled by default
        if (this.isDclClRefactorPhase2() &&
            !this.model.some(function (item) { return item.type === _this.constants.filters['privateIsland'].id; })) {
            filterArray.push([]);
        }
        return filterArray;
    };
    /**
     * Get selected filters from URL or cookie to select them in the QuickQuoteBar
     * @param updateURL flag to update the url
     * @param reservationSummary the reservation summary
     * @returns Filters selected as a string array
     */
    QuickQuoteService.prototype.getPreSelectedFilters = function (updateURL, reservationSummary) {
        var preSelectedFilters = this.getFiltersFromBrowser(updateURL);
        if (!preSelectedFilters && reservationSummary) {
            preSelectedFilters = this.captureFiltersFromSession(reservationSummary);
        }
        preSelectedFilters = preSelectedFilters && preSelectedFilters.replace('/', '');
        if (preSelectedFilters) {
            if (this.model) {
                var validFilters = this.getValidFilters(preSelectedFilters);
                preSelectedFilters = validFilters.join();
                this.updateSelectedFiltersFromPreSelectedFilters(preSelectedFilters);
                this.updateFilterLabelValuesFromSelectedFilters(this.selectedFilters);
                this.mergeDoneIntoSelectedFilters();
                this.mergeIntoTempSelectedFilters();
                this.updateCookieValueFromSelectedFilters();
                this.sendSelectedFilters(validFilters);
                if (updateURL) {
                    this.updateURLFromCookieValue();
                }
            }
            if (!_.get(this.selectedFiltersList, 'length')) {
                this.selectedFiltersList = this.getFilterOptions(preSelectedFilters);
            }
        }
        return this.selectedFiltersList;
    };
    /**
     * Get valid filters by comparing the preselected filters with the filter service response
     * @params preselectedFilters. Filters selected got from browser
     * @returns valid filters array
     */
    QuickQuoteService.prototype.getValidFilters = function (preselectedFilters) {
        var _this = this;
        var portsDelimiter = this.constants.urlDelimiters.ports;
        return preselectedFilters.split(',').filter(function (filterValue) {
            return filterValue.startsWith(portsDelimiter) || _.find(_this.filtersData, function (filterItem) {
                return filterItem.urlFriendlyId === filterValue;
            });
        });
    };
    /**
     * Get location path
     * @params delimiter threshold value to fragment the url
     * @params withHash [withHash=false] says if the path obtained should include the hash
     * @returns location path needed
     */
    QuickQuoteService.prototype.getLocationPath = function (delimiter, withHash) {
        if (withHash === void 0) { withHash = false; }
        var locationPath = '';
        if (this.location.path(withHash).includes(delimiter)) {
            locationPath = this.location.path(withHash).split(delimiter)[1];
        }
        return locationPath;
    };
    /**
     * Get filter values from either address bar or cookies
     * @param updateURL flag to update URL
     * @returns selected filters as string value
     */
    QuickQuoteService.prototype.getFiltersFromBrowser = function (updateURL) {
        var reservationId = this.reservationIdService.getId();
        var hashFilters = this.getLocationPath(this.urlDelimiters.hash, true);
        var itemStorage = this.localStorageService.getItemStorage(this.constants.localStorage.specialFilters, true);
        var filterAddressBar = '';
        var filterCookieValue = '';
        var specialFilter = this.getLocationPath(this.urlDelimiters.filteredPort);
        var specialFilterStorage = '';
        specialFilterStorage = itemStorage && itemStorage[this.constants.specialFiltersTypes.portOfCall];
        specialFilterStorage = this.getSpecialFilterValue.apply(this, [updateURL].concat([
            this.getLocalFilters(reservationId),
            hashFilters,
            this.location.path(),
            specialFilterStorage
        ]));
        specialFilter = specialFilter || specialFilterStorage;
        filterCookieValue = this.getLocalFilters(reservationId);
        filterAddressBar = this.getAddressBarFilter.apply(this, [
            filterCookieValue,
            hashFilters,
            specialFilter
        ]);
        return filterAddressBar || filterCookieValue;
    };
    /**
     * Get address bar filter value
     * @param addressBarFilters Array of params used for the validation
     * @returns address bar filter value
     */
    QuickQuoteService.prototype.getAddressBarFilter = function () {
        var addressBarFilters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            addressBarFilters[_i] = arguments[_i];
        }
        var filterCookieValue = addressBarFilters[0], hashFilters = addressBarFilters[1], specialFilter = addressBarFilters[2];
        var filterAddressBar = '';
        if (specialFilter) {
            var commonFilters = hashFilters || filterCookieValue;
            filterAddressBar = (commonFilters && specialFilter + "," + commonFilters) || specialFilter;
        }
        else if (hashFilters) {
            filterAddressBar = hashFilters;
        }
        return filterAddressBar;
    };
    /**
     * Get special filters value
     * @param updateURL Flag to update URL
     * @param filterParams Array of params used for the validation
     * @returns special filter value
     */
    QuickQuoteService.prototype.getSpecialFilterValue = function (updateURL) {
        var filterParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            filterParams[_i - 1] = arguments[_i];
        }
        var reservationId = this.reservationIdService.getId();
        var filterCookieValue = filterParams[0], hashFilters = filterParams[1], pathWithoutHash = filterParams[2], specialFilterStorage = filterParams[3];
        var filteredPortDelimiter = "?" + this.constants.urlDelimiters.filteredPort;
        var specialFilterValue = specialFilterStorage || '';
        // Only updates the url if no hash, there are special filters in localStorage, but they are not in the url
        // This case is when the user navigates from another page
        if (!hashFilters && specialFilterStorage && !pathWithoutHash.includes(filteredPortDelimiter)) {
            if (updateURL) {
                this.location.go(this.location.path() + ("" + filteredPortDelimiter + specialFilterStorage));
            }
            // Avoid requesting for products with wrong special filters
            // Case when user navigates with new filters selected from another page
        }
        else if (hashFilters && hashFilters !== filterCookieValue && specialFilterStorage) {
            specialFilterValue = '';
            localStorage.removeItem(this.constants.localStorage.specialFilters);
            this.saveFiltersLocally(reservationId, hashFilters);
        }
        return specialFilterValue;
    };
    /**
     * Functions that iterates over the model to find match the filters that are been pre selected and select them
     * and add it to selectedFilters array
     * @param filters
     */
    QuickQuoteService.prototype.updateSelectedFiltersFromPreSelectedFilters = function (filters) {
        var _this = this;
        var preSelectedFilters = filters.split(',');
        this.model.forEach(function (filter, filterIndex) {
            switch (filter.type) {
                case _this.constants.filters['date'].id:
                    filter.data.forEach(function (gridConfig) {
                        gridConfig.contentData.forEach(function (gridContent) {
                            if (preSelectedFilters.includes(gridContent.urlFriendlyId)) {
                                var itemFilterSelected = {
                                    id: gridContent.id,
                                    urlFriendlyId: gridContent.urlFriendlyId,
                                    type: filter.type
                                };
                                gridContent.isSelected = true;
                                _this.filtersUtils.addByFilterName(itemFilterSelected, _this.selectedFilters[filterIndex], _this.filtersData);
                            }
                        });
                    });
                    break;
                case _this.constants.filters['privateIsland'].id:
                case _this.constants.filters['destination'].id:
                case _this.constants.filters['city'].id:
                    filter.data.forEach(function (imagePicker) {
                        if (preSelectedFilters.includes(imagePicker.urlFriendlyId)) {
                            var itemFilterSelected = {
                                id: imagePicker.id,
                                urlFriendlyId: imagePicker.urlFriendlyId,
                                type: filter.type
                            };
                            imagePicker.selected = true;
                            _this.filtersUtils.addByFilterName(itemFilterSelected, _this.selectedFilters[filterIndex], _this.filtersData);
                        }
                    });
                    break;
                case _this.constants.filters['more-filters'].id:
                    filter.data.forEach(function (optionsGroup, optionsGroupIndex) {
                        optionsGroup.options.forEach(function (optionItem) {
                            if (preSelectedFilters.includes(optionItem.urlFriendlyId)) {
                                var itemFilterSelected = {
                                    id: optionItem.id,
                                    urlFriendlyId: optionItem.urlFriendlyId,
                                    type: filter.type,
                                    groupType: optionsGroup.type
                                };
                                optionItem.selected = true;
                                if (optionsGroup.type === _this.constants.filters['more-filters'].groupKey.night) {
                                    _this.filtersUtils.addByFilterNights(itemFilterSelected, _this.selectedFilters[filterIndex][optionsGroupIndex]);
                                }
                                else {
                                    _this.filtersUtils.addByFilterName(itemFilterSelected, _this.selectedFilters[filterIndex][optionsGroupIndex], _this.filtersData);
                                }
                            }
                        });
                    });
                    break;
            }
        });
    };
    /**
     * Manage the onChangedFilterItem event.
     * @param itemFilterChanged
     */
    QuickQuoteService.prototype.changedFilterItem = function (itemFilterChanged) {
        var filterIndex = this.model.findIndex(function (filterData) {
            return filterData.type === itemFilterChanged.filterType;
        });
        if (itemFilterChanged.isSelected) {
            this.addItemToTempSelectedFilters(itemFilterChanged, filterIndex);
        }
        else {
            this.removeItemFromTempSelectedFilters(itemFilterChanged, filterIndex);
        }
        this.updateFilterLabelValuesFromSelectedFilters(this.tempSelectedFilters);
    };
    /**
     * Update the sub heading value based on the travelParty count
     * @param travelpartyCount
     */
    QuickQuoteService.prototype.changedTravelPartyCount = function (travelpartyCount) {
        var _this = this;
        var travelPartyIndex = this.model.findIndex(function (filter) {
            return filter.type === _this.constants.filters['travel-party'].id;
        });
        this.model[travelPartyIndex].value = this.getTranslatedTravelPartySubHeading(travelpartyCount);
        this.model[travelPartyIndex].modalValue = this.model[travelPartyIndex].value;
    };
    /**
     * Add the item to the selectedFilters object depending on the filter type
     * @param itemFilterChanged
     * @param filterIndex
     */
    QuickQuoteService.prototype.addItemToTempSelectedFilters = function (itemFilterChanged, filterIndex) {
        if (itemFilterChanged.filterType === this.constants.filters['more-filters'].id) {
            var groupTypeIndex = this.model[filterIndex].data.findIndex(function (optionsGroup) {
                return optionsGroup.type === itemFilterChanged.groupType;
            });
            var itemSelected = {
                groupType: itemFilterChanged.groupType,
                id: itemFilterChanged.id,
                type: itemFilterChanged.filterType,
                urlFriendlyId: itemFilterChanged.urlFriendlyId
            };
            // TODO: GroupKey could be moved to an object
            if (itemFilterChanged.groupType === this.constants.filters['more-filters'].groupKey.night) {
                this.filtersUtils.addByFilterNights(itemSelected, this.tempSelectedFilters[filterIndex][groupTypeIndex]);
            }
            else {
                this.filtersUtils.addByFilterName(itemSelected, this.tempSelectedFilters[filterIndex][groupTypeIndex], this.filtersData);
            }
        }
        else if (itemFilterChanged.filterType !== this.constants.filters['travel-party'].id) {
            var itemSelected = {
                id: itemFilterChanged.id,
                type: itemFilterChanged.filterType,
                urlFriendlyId: itemFilterChanged.urlFriendlyId
            };
            this.filtersUtils.addByFilterName(itemSelected, this.tempSelectedFilters[filterIndex], this.filtersData);
        }
    };
    /**
     * Remove the item from selectedFilters
     * @param itemFilterChanged
     * @param filterIndex
     */
    QuickQuoteService.prototype.removeItemFromTempSelectedFilters = function (itemFilterChanged, filterIndex) {
        if (itemFilterChanged.filterType === this.constants.filters['more-filters'].id) {
            var groupTypeIndex = this.model[filterIndex].data.findIndex(function (optionsGroup) {
                return optionsGroup.type === itemFilterChanged.groupType;
            });
            var selectedFilters = this.tempSelectedFilters[filterIndex][groupTypeIndex];
            var index = selectedFilters.findIndex(function (selectedFilter) {
                return selectedFilter.id === itemFilterChanged.id;
            });
            if (index >= 0) {
                selectedFilters.splice(index, 1);
            }
        }
        else {
            var index = this.tempSelectedFilters[filterIndex].findIndex(function (selectedFilter) {
                return selectedFilter.id === itemFilterChanged.id;
            });
            this.tempSelectedFilters[filterIndex].splice(index, 1);
        }
    };
    /**
     * Updates the URL based on the cookie value
     */
    QuickQuoteService.prototype.updateURLFromCookieValue = function () {
        var reservationId = this.reservationIdService.getId();
        var cookieValue = this.getLocalFilters(reservationId);
        if (cookieValue) {
            this.location.go(this.location.path() + this.urlDelimiters.hash + cookieValue);
        }
        else {
            this.location.go(this.location.path());
        }
    };
    /**
     * Send applied filters
     * @param selectedFilters Selected filters as array
     */
    QuickQuoteService.prototype.sendSelectedFilters = function (selectedFilters) {
        this.urlFilters.next(selectedFilters);
    };
    /**
     * Get filters displayed in the address bar as a string array
     * @returns filters applied
     */
    QuickQuoteService.prototype.getSelectedFilters = function () {
        return this.urlFilters;
    };
    /**
     * Retrives the list of properties of the selected filters list based on SelectedFiltersModel
     *
     * @param prop the property of the SelectedFilter
     * @returns array string list (ie: ["2020-10;filterType=date"])
     */
    QuickQuoteService.prototype.getSelectedFiltersBy = function (prop) {
        return _.flatten(this.selectedFilters)
            .filter(function (item) { return Object.keys(item).length; })
            .map(function (item) { return item[prop]; });
    };
    /**
     * Functions that helps to add string into an accumulator. Separator is used to separates each
     * string added
     * @param value
     * @param accumulator
     * @param separator Optional. Default ','
     */
    QuickQuoteService.prototype.addToStringAccumulator = function (value, accumulator, separator) {
        if (separator === void 0) { separator = ','; }
        if (accumulator && value) {
            accumulator += separator + value;
        }
        else if (value) {
            accumulator = value;
        }
        return accumulator;
    };
    /**
     * Updates the filter label value for each filter from selection object
     * @param selectedFilters selectedFilters/tempSelectedFilter
     */
    QuickQuoteService.prototype.updateFilterLabelValuesFromSelectedFilters = function (selectedFilters) {
        var _this = this;
        this.model.map(function (filterData, filterDataindex) {
            var filterValueLabel = '';
            var filterCount = selectedFilters[filterDataindex].length;
            if (filterData.type === _this.constants.filters['date'].id) {
                selectedFilters[filterDataindex].forEach(function (selectedFilter) {
                    filterValueLabel = _this.updateDateFilterValue(selectedFilter.id, filterValueLabel);
                });
            }
            if (filterData.type === _this.constants.filters['destination'].id ||
                filterData.type === _this.constants.filters['privateIsland'].id ||
                filterData.type === _this.constants.filters['city'].id) {
                selectedFilters[filterDataindex].forEach(function (selectedFilter) {
                    filterValueLabel = _this.addToStringAccumulator(_this.filtersData[selectedFilter.id].name, filterValueLabel, ', ');
                });
                // hack to make privateIsland and destination as one group
                // @TODO remove then once filters support subgroups
                if (_this.isDclClRefactorPhase2()) {
                    filterValueLabel = _this.fixLabelForPrivateIsland(filterData, selectedFilters, filterValueLabel);
                    filterCount = _this.fixCountForPrivateIslandAndDestination(filterData, selectedFilters, filterCount);
                    filterData = _this.fixDataForPrivateIsland(filterData);
                }
            }
            if (filterData.type === _this.constants.filters['more-filters'].id) {
                selectedFilters[filterDataindex].forEach(function (moreFilterGroup) {
                    moreFilterGroup.forEach(function (filter) {
                        filterValueLabel = _this.addToStringAccumulator(_this.filtersData[filter.id].name, filterValueLabel, ', ');
                    });
                });
            }
            if (filterData.type !== _this.constants.filters['travel-party'].id) {
                if (filterValueLabel) {
                    _this.setFilterDataValues(filterData, filterValueLabel, filterCount);
                }
                else {
                    var translationkeys = _this.getTranslationKeys(filterData.type);
                    if (translationkeys) {
                        filterData.value = translationkeys.defaultValue;
                        filterData.modalValue = translationkeys.defaultValue;
                    }
                }
            }
        });
    };
    /**
     * Return the Destination data object when match PrivateIsland
     * @TODO this should be removed whe QQ support subgroups
     * @param filterData
     * @returns {Filter} destination group
     */
    QuickQuoteService.prototype.fixDataForPrivateIsland = function (filterData) {
        var _this = this;
        if (filterData.type === this.constants.filters['privateIsland'].id) {
            filterData = this.model.find(function (item) { return item.type === _this.constants.filters['destination'].id; });
        }
        return filterData;
    };
    /**
     * Merge labels names of filters selected for Destination & Private Island
     * @param filterData
     * @param selectedFilters
     * @param filterValueLabel
     * @returns {string} all valid labels strings separated by coma
     */
    QuickQuoteService.prototype.fixLabelForPrivateIsland = function (filterData, selectedFilters, filterValueLabel) {
        var _this = this;
        if (filterData.type === this.constants.filters['privateIsland'].id) {
            selectedFilters[this.constants.filters['destination'].renderOrder]
                .forEach(function (selectedFilter) {
                filterValueLabel = _this.addToStringAccumulator(_this.filtersData[selectedFilter.id].name, filterValueLabel, ', ');
            });
        }
        else if (filterData.type === this.constants.filters['destination'].id) {
            selectedFilters[this.constants.filters['privateIsland'].renderOrder]
                .forEach(function (selectedFilter) {
                filterValueLabel = _this.addToStringAccumulator(_this.filtersData[selectedFilter.id].name, filterValueLabel, ', ');
            });
        }
        return filterValueLabel;
    };
    /**
     * Merge total result of filters selected for Destination & Private Island
     * @param filterData
     * @param selectedFilters
     * @param filterCount
     * @returns {int} number of total filters
     */
    QuickQuoteService.prototype.fixCountForPrivateIslandAndDestination = function (filterData, selectedFilters, filterCount) {
        if (filterData.type === this.constants.filters['privateIsland'].id) {
            filterCount += selectedFilters[this.constants.filters['destination'].renderOrder].length;
        }
        else if (filterData.type === this.constants.filters['destination'].id) {
            filterCount += selectedFilters[this.constants.filters['privateIsland'].renderOrder].length;
        }
        return filterCount;
    };
    /**
     * Assigns the corresponding value to the filter data for desktop and mobile based on the amount
     * of filters selected
     * @param filterData
     * @param filterValueLabel
     * @param filterCount
     */
    QuickQuoteService.prototype.setFilterDataValues = function (filterData, filterValueLabel, filterCount) {
        if (filterCount === 1) {
            filterData.value = filterValueLabel;
        }
        else if (filterCount > 1 && filterData.type !== this.constants.filters['more-filters'].id) {
            filterData.value = this.translate.instant(this.constants.filters[filterData.type].countValue, { count: filterCount });
        }
        filterData.modalValue = filterValueLabel;
    };
    /**
     * Function that format the filter date id to it respective filter value date form
     * example: June 2020
     * @param filterId date filter id
     * @param filterValueLabel Initial accumulator string
     * @returns {string} date filter value
     */
    QuickQuoteService.prototype.updateDateFilterValue = function (filterId, filterValueLabel) {
        var moment = momentImported;
        var dateString = filterId.split(';')[0];
        var momentDate = moment(dateString, 'YYYY-MM');
        var dateValue = momentDate.format('MMMM YYYY');
        return this.addToStringAccumulator(dateValue, filterValueLabel, ', ');
    };
    /**
     * Updates cookie value based on the selected filters
     */
    QuickQuoteService.prototype.updateCookieValueFromSelectedFilters = function () {
        var _this = this;
        var reservationId = this.reservationIdService.getId();
        var cookieValue = '';
        this.model.forEach(function (filterData, filterIndex) {
            var urlFilterValue = '';
            if (filterData.type === _this.constants.filters['more-filters'].id) {
                _this.selectedFilters[filterIndex]
                    .forEach(function (selectedFilter) {
                    selectedFilter.forEach(function (groupType) {
                        urlFilterValue = _this.addToStringAccumulator(groupType.urlFriendlyId, urlFilterValue);
                    });
                });
            }
            else if (filterData.type !== _this.constants.filters['travel-party'].id) {
                _this.selectedFilters[filterIndex]
                    .forEach(function (selectedFilter) {
                    urlFilterValue = _this.addToStringAccumulator(selectedFilter.urlFriendlyId, urlFilterValue);
                });
            }
            cookieValue = _this.addToStringAccumulator(urlFilterValue, cookieValue);
        });
        if (cookieValue) {
            this.saveFiltersLocally(reservationId, cookieValue);
        }
        else {
            this.removeFiltersLocally();
        }
    };
    /**
     * Removes the filters from the session storage
     */
    QuickQuoteService.prototype.removeFiltersLocally = function () {
        var reservationId = this.reservationIdService.getId();
        var storageKey = this.getStorageKey(reservationId);
        if (reservationId) {
            this.sessionStorageService.removeItem(storageKey);
        }
        else {
            this.cookieService.delete(storageKey, '/');
        }
    };
    /**
     * Emit an event with the filters that have been selected
     */
    QuickQuoteService.prototype.applyFilters = function () {
        var filters = this.getSelectedFiltersToApply();
        var filtersValues;
        this.mergeIntoDoneFilters();
        filtersValues = this.getFiltersValues(filters);
        this.onApplyFilters.next(filtersValues);
    };
    /**
     * Retrieves an array of filters values based on array of filters ids
     * @param filtersId filters ids array
     * @returns Filters values array
     */
    QuickQuoteService.prototype.getFiltersValues = function (filtersId) {
        var _this = this;
        return filtersId.map(function (filterId) { return _this.filtersData[filterId].filterValue; });
    };
    /**
     * Get filter options as a string array
     * @param selectedFilters Selected filters as a string value
     * @returns Filter options
     */
    QuickQuoteService.prototype.getFilterOptions = function (selectedFilters) {
        var _this = this;
        var filterOptions = [];
        if (selectedFilters) {
            filterOptions = selectedFilters.split(',').map(function (selectedFilter) { return selectedFilter + _this.constants.filters.preSelectedFiltersSuffix; });
        }
        return filterOptions;
    };
    /**
     * Clears all filters for the filter type provided
     * @param filterType filter type
     */
    QuickQuoteService.prototype.clearFiltersByType = function (filterType) {
        this.removeFiltersByType(filterType, this.model);
        this.removeSelectedFiltersByType(filterType, this.tempSelectedFilters, this.model);
    };
    /**
     * this function calls the clear all filter function from util
     * sending the model already create and the filters already selected,
     * clears the temporary selected object and
     * also clears the cookieValues and the url values already saved
     * @param updateURL flag to update the url
     */
    QuickQuoteService.prototype.clearAllFilters = function (updateURL) {
        if (this.model && this.selectedFilters) {
            this.clearAllFiltersUtil(this.model, this.selectedDoneFilters);
            this.clearAllFiltersUtil(this.model, this.selectedFilters);
            this.clearAllFiltersUtil(this.model, this.tempSelectedFilters);
            this.updateFilterLabelValuesFromSelectedFilters(this.selectedFilters);
            this.updateCookieValueFromSelectedFilters();
            if (updateURL) {
                this.location.go(this.location.path().split('?')[0]);
            }
            localStorage.removeItem(this.constants.localStorage.specialFilters);
            delete this.specialFilter;
        }
    };
    /**
     * Restores the temporary selected filters with the actual selected filters.
     * Updates selections states in the model.
     *
     * @param filterIndex
     * @param closeModal
     */
    QuickQuoteService.prototype.cancelFilterSelections = function (filterIndex, closeModal) {
        var filter = this.model[filterIndex];
        var filtersActionType;
        if (closeModal) {
            filtersActionType = this.selectedFilters;
            this.mergeDoneIntoSelectedFilters();
        }
        else {
            filtersActionType = this.selectedDoneFilters;
        }
        this.updateFilterLabelValuesFromSelectedFilters(filtersActionType);
        this.mergeIntoTempSelectedFilters();
        switch (filter.type) {
            case this.constants.filters['date'].id:
                filter.data.forEach(function (gridConfig) {
                    gridConfig.contentData.forEach(function (gridContent) {
                        var selectedFilters = filtersActionType[filterIndex];
                        var isFilterSelected = selectedFilters.find(function (selectedFilter) {
                            return selectedFilter.id === gridContent.id;
                        });
                        gridContent.isSelected = !!isFilterSelected;
                    });
                });
                break;
            case this.constants.filters['privateIsland'].id:
            case this.constants.filters['destination'].id:
            case this.constants.filters['city'].id:
                filter.data.forEach(function (imagePicker) {
                    var selectedFilters = filtersActionType[filterIndex];
                    var isFilterSelected = selectedFilters.find(function (selectedFilter) {
                        return selectedFilter.id === imagePicker.id;
                    });
                    imagePicker.selected = !!isFilterSelected;
                });
                break;
            case this.constants.filters['more-filters'].id:
                filter.data.forEach(function (optionsGroup, optionGroupIndex) {
                    optionsGroup.options.forEach(function (optionItem) {
                        var selectedFilters = filtersActionType[filterIndex][optionGroupIndex];
                        var isFilterSelected = selectedFilters.find(function (selectedFilter) {
                            return selectedFilter.id === optionItem.id;
                        });
                        optionItem.selected = !!isFilterSelected;
                    });
                });
                break;
            case this.constants.filters['travel-party'].id:
                this.travelPartyService.resetStaterooms();
                this.changedTravelPartyCount(this.travelPartyService.getTravelPartyCount());
                break;
        }
    };
    /**
     * Copy the values from tempSelectedFilters to selectedFilters
     */
    QuickQuoteService.prototype.mergeIntoSelectedFilters = function () {
        this.selectedFilters = _.cloneDeep(this.tempSelectedFilters);
    };
    /**
     * Copy the values from selectedFilters to tempSelectedFilters
     */
    QuickQuoteService.prototype.mergeIntoTempSelectedFilters = function () {
        this.tempSelectedFilters = _.cloneDeep(this.selectedDoneFilters);
    };
    /**
     * Copy the values from tempSelectedFilters to selectedDoneFilters
     */
    QuickQuoteService.prototype.mergeIntoDoneFilters = function () {
        this.selectedDoneFilters = _.cloneDeep(this.tempSelectedFilters);
    };
    /**
     * Copy the values from selectedFilters to selectedDoneFilters
     */
    QuickQuoteService.prototype.mergeDoneIntoSelectedFilters = function () {
        this.selectedDoneFilters = _.cloneDeep(this.selectedFilters);
    };
    /**
     * Returns an observable to know when focus should go to the Quick Quote Bar
     * @returns Observable to watch when the Quick Quote Bar should be focused
     */
    QuickQuoteService.prototype.getFocusBar = function () {
        return this.focusBar;
    };
    /**
     * Emits a new item for the focusBar Observable to send the focus to the Quick Quote Bar
     * based on the filter type and direction provided
     * @param filterType Filter type
     * @param direction Direction to focus, 1 to right and -1 to left
     */
    QuickQuoteService.prototype.focusToBar = function (filterType, direction) {
        var index = this.model.findIndex(function (filter) { return filter.type === filterType; });
        // indicates what is the last filter displayed in the qq bar
        var lastFilterBarIndex = this.model.findIndex(function (filter) { return filter.type === 'more-filters'; });
        if (direction === 1) {
            if (index === lastFilterBarIndex) {
                this.focusBar.next();
            }
            else if (this.filterHasErrors(index)) {
                this.focusBar.next("tab-" + index);
            }
            else {
                this.focusBar.next("tab-" + (index + 1));
            }
        }
        else {
            this.focusBar.next("tab-" + index);
        }
    };
    /**
     * Gets the options group filters from quick quote service
     *
     * @param filterType to be returned
     * @returns filter OptionGroup value
     */
    QuickQuoteService.prototype.getOptionGroupFiltersByType = function (filterType) {
        var moreFiltersConstants = this.constants.filters['more-filters'];
        if (this.model && this.model[moreFiltersConstants.renderOrder].data) {
            this.contextualFilterGroup =
                this.model[moreFiltersConstants.renderOrder].data.filter(function (filters) {
                    return filters.type === filterType;
                })[0];
            return this.contextualFilterGroup;
        }
    };
    /**
     * Get the filter id selected from filters that has been selected previously
     *
     * @param itemFilterChange selected filter
     * @param appliedFilters current applied filters
     * @returns filter id
     */
    QuickQuoteService.prototype.getSelectedFilterByID = function (itemFilterChange, appliedFilters) {
        var selectedFilter = '';
        appliedFilters.forEach(function (filter) {
            var filterId = filter.split(';')[0];
            var currentFilterId = itemFilterChange.id.split(';')[0];
            var currentFilterFriendlyId = itemFilterChange.urlFriendlyId;
            if (filterId === currentFilterId || filterId === currentFilterFriendlyId) {
                selectedFilter = filter;
            }
        });
        return selectedFilter;
    };
    /**
     * Disable all the contextual filters
     */
    QuickQuoteService.prototype.disableContextualFilters = function () {
        if (this.contextualFilterGroup) {
            this.temporalContextualFilterGroup = _.cloneDeep(this.contextualFilterGroup);
            this.contextualFilterGroup.options.forEach(function (optionItem) { return optionItem.disabled = true; });
        }
    };
    /**
     * Enable the contextual filters that were previous enabled
     */
    QuickQuoteService.prototype.enablePreviousSelectedFilters = function () {
        if (this.contextualFilterGroup && this.temporalContextualFilterGroup) {
            Object.assign(this.contextualFilterGroup, this.temporalContextualFilterGroup);
        }
    };
    /**
     * Set the dclClRefactorPhase toggle status in this service
     * @param dclClRefactorPhase2Toogle
     */
    QuickQuoteService.prototype.setIsDclClRefactorPhase2 = function (dclClRefactorPhase2Toogle) {
        this.dclClRefactorPhase2Toogle = dclClRefactorPhase2Toogle;
    };
    /**
     * Determine if dclClRefactorPhase toggle status is ON
     * @returns toggle status value
     */
    QuickQuoteService.prototype.isDclClRefactorPhase2 = function () {
        return !!this.dclClRefactorPhase2Toogle;
    };
    /**
     * Set the DclAdvancedBooking toggle status in this service
     * @param dclAdvancedBooking
     */
    QuickQuoteService.prototype.setIsDclAdvancedBooking = function (dclAdvancedBooking) {
        this.dclAdvancedBooking = dclAdvancedBooking;
    };
    /**
     * Determine if DclAdvancedBooking toggle status is ON
     * @returns toggle status value
     */
    QuickQuoteService.prototype.isDclAdvancedBooking = function () {
        return this.dclAdvancedBooking;
    };
    /**
     * Get the current selected filter ids as string array
     * @returns array with selected ids
     */
    QuickQuoteService.prototype.getSelectedFiltersToApply = function () {
        var _this = this;
        var filters = [];
        this.model.forEach(function (filterData, filterIndex) {
            if (filterData.type === _this.constants.filters['more-filters'].id) {
                _this.selectedFilters[filterIndex]
                    .forEach(function (groupType) {
                    groupType.forEach(function (selectedFilter) {
                        filters.push(selectedFilter.id);
                    });
                });
            }
            else {
                _this.selectedFilters[filterIndex]
                    .forEach(function (selectedFilter) {
                    filters.push(selectedFilter.id);
                });
            }
        });
        return filters;
    };
    /**
     * Enables selected status for filters based on actions received as param
     * @param action - array of filter actions that have to be selected
     */
    QuickQuoteService.prototype.selectFilters = function (action) {
        var _this = this;
        this.getModel().forEach(function (filter) {
            var typeDate = filter.type === _this.constants.filters['date'].id;
            var typeMoreFilters = filter.type === _this.constants.filters['more-filters'].id;
            if (typeDate || typeMoreFilters) {
                filter.data.forEach(function (filterData) {
                    if ('options' in filterData) {
                        _this.setIsSelected(filterData.options, action);
                    }
                    else {
                        _this.setIsSelected(filterData.contentData, action);
                    }
                });
            }
            else {
                _this.setIsSelected(filter.data, action);
            }
        });
    };
    /**
     * Sets selected status
     * @param filterData - data model for a particular filter group
     * @param action - array of actions
     */
    QuickQuoteService.prototype.setIsSelected = function (filterData, action) {
        filterData.forEach(function (filterItem) {
            var hasSomeUrlFriendlyId = _.some(action, ['urlFriendlyId', filterItem.urlFriendlyId]);
            var currentSelectedStatus = _.get(filterItem, 'selected') || _.get(filterItem, 'isSelected');
            if ('selected' in filterItem) {
                filterItem.selected = hasSomeUrlFriendlyId || currentSelectedStatus;
            }
            else {
                filterItem.isSelected = hasSomeUrlFriendlyId || currentSelectedStatus;
            }
        });
    };
    /**
     * Capture filters from the reservation summary session
     * @param reservationSummary the reservation summary session
     * @returns Captured filters as a string
     */
    QuickQuoteService.prototype.captureFiltersFromSession = function (reservationSummary) {
        var filters = [];
        var sailYearMonthFilter = reservationSummary.sailYearMonth ?
            this.parseUrlFriendlyId([reservationSummary.sailYearMonth,
                QUICK_QUOTE_CONSTANTS.filterTypes.date].join(';')) :
            '';
        if (sailYearMonthFilter) {
            filters.push(sailYearMonthFilter);
        }
        var destinationFilter = reservationSummary.destinationId ?
            this.parseUrlFriendlyId([reservationSummary.destinationId,
                QUICK_QUOTE_CONSTANTS.filterTypes.destination].join(';')) :
            '';
        if (destinationFilter) {
            filters.push(destinationFilter);
        }
        var portFromFilter = reservationSummary.portFromId ?
            this.parseUrlFriendlyId([reservationSummary.portFromId,
                QUICK_QUOTE_CONSTANTS.filterTypes.city].join(';')) :
            '';
        if (portFromFilter) {
            filters.push(portFromFilter);
        }
        return filters.join(',');
    };
    /**
     * Parses the urlFriendlyId from the filter data
     * @param key the filter key
     * @returns the urlFriendlyId
     */
    QuickQuoteService.prototype.parseUrlFriendlyId = function (key) {
        return this.filtersData[key] && this.filtersData[key].urlFriendlyId;
    };
    /**
     * Returns an observable to know when focus should go to the Quick Quote Bar
     * @returns Observable to subscribe for changes when the Quick Quote Bar should be focused
     */
    QuickQuoteService.prototype.getModelChangedObservable = function () {
        return this.modelChanged$;
    };
    /**
     * Saves the filter in the session storage if the reservation id was provided,
     * otherwise, saves the filter in the cookie service
     * @param reservationId The reservation Id
     * @param value The stringify filters
     */
    QuickQuoteService.prototype.saveFiltersLocally = function (reservationId, value) {
        var storageKey = this.getStorageKey(reservationId);
        if (reservationId) {
            this.sessionStorageService.setItem(storageKey, value);
        }
        else {
            this.cookieService.set(storageKey, value, null, '/');
        }
    };
    /**
     * Returns the stringify filters from the session storage if the reservation id was provided
     * otherwise, return the stringify filters from the cookie
     * @param reservationId The reservation Id
     */
    QuickQuoteService.prototype.getLocalFilters = function (reservationId) {
        var storageKey = this.getStorageKey(reservationId);
        if (reservationId) {
            return this.sessionStorageService.getItem(storageKey);
        }
        return this.cookieService.get(storageKey);
    };
    /**
     * Returns the storage key according to the reservation id
     * @param reservationId The reservation Id
     */
    QuickQuoteService.prototype.getStorageKey = function (reservationId) {
        if (reservationId) {
            return this.constants.cookie.name + "-" + reservationId;
        }
        return this.constants.cookie.name;
    };
    QuickQuoteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QuickQuoteService_Factory() { return new QuickQuoteService(i0.ɵɵinject(i1.CookieService), i0.ɵɵinject(i2.EventService), i0.ɵɵinject(i3.LocalStorageService), i0.ɵɵinject(i4.Location), i0.ɵɵinject(i5.ReservationIdService), i0.ɵɵinject(i6.SessionStorageService), i0.ɵɵinject(i7.TranslateService), i0.ɵɵinject(i8.TravelPartyService), i0.ɵɵinject(i9.WindowRef)); }, token: QuickQuoteService, providedIn: "root" });
    return QuickQuoteService;
}());
export { QuickQuoteService };
